import { useEffect, useState } from 'react';

const entries = [
  {
    key: 'app',
    icon: 'ri-smartphone-line',
    title: '下载 17黑料网 App',
    desc: '订阅更新条推送，避雷名单一有变动就提醒你，浏览档案也更顺手。',
    action: '下载客户端',
    tone: 'primary' as const,
    meta: 'iOS · Android',
  },
  {
    key: 'group',
    icon: 'ri-group-line',
    title: '加入讨论群入口',
    desc: '按兴趣分区入群，第一时间看到新增证言与原帖更新，讨论氛围更集中。',
    action: '获取入口',
    tone: 'secondary' as const,
    meta: '12 个分区群',
  },
  {
    key: 'tip',
    icon: 'ri-edit-2-line',
    title: '提交线索与纠错',
    desc: '发现档案有偏差，或想补充一条被忽略的说法，都可以通过这里反馈。',
    action: '我要提交',
    tone: 'outline' as const,
    meta: '48 小时内处理',
  },
];

export default function JoinPanel() {
  const [toast, setToast] = useState('');

  useEffect(() => {
    if (!toast) {
      return undefined;
    }
    const timer = setTimeout(() => setToast(''), 2600);
    return () => clearTimeout(timer);
  }, [toast]);

  return (
    <section id="join" className="relative w-full bg-foreground-950 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col gap-4 border-b border-background-50/15 pb-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="font-label text-[11px] uppercase tracking-[0.34em] text-accent-400">
              分区 06 · 入口
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold leading-snug text-background-50 md:text-[32px]">
              把入口放在最顺手的位置
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-300">
              避雷这件事越方便越好。下载客户端、进讨论群，或者直接提交一条线索，三种方式任选。
            </p>
          </div>
          <span className="flex shrink-0 items-center gap-2 font-label text-[12px] text-background-300">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-lock-2-line text-base text-accent-400" />
            </span>
            演示站点 · 入口暂不接入真实服务
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {entries.map((entry) => {
            const isPrimary = entry.tone === 'primary';
            const isSecondary = entry.tone === 'secondary';
            return (
              <div
                key={entry.key}
                className={
                  isPrimary
                    ? 'flex flex-col rounded-lg border border-primary-400/60 bg-primary-500/12 p-5 md:p-6'
                    : isSecondary
                      ? 'flex flex-col rounded-lg border border-background-50/15 bg-background-50/8 p-5 md:p-6'
                      : 'flex flex-col rounded-lg border border-dashed border-background-50/25 p-5 md:p-6'
                }
              >
                <span
                  className={
                    isPrimary
                      ? 'flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50'
                      : isSecondary
                        ? 'flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50'
                        : 'flex h-11 w-11 items-center justify-center rounded-md border border-background-50/25 text-accent-300'
                  }
                >
                  <i className={`${entry.icon} text-xl`} />
                </span>

                <h3 className="mt-4 font-heading text-lg font-bold text-background-50">
                  {entry.title}
                </h3>
                <p className="mt-2.5 flex-1 text-[13px] leading-relaxed text-background-300">
                  {entry.desc}
                </p>

                <div className="mt-5 flex items-center justify-between gap-3">
                  <button
                    type="button"
                    onClick={() => setToast(`「${entry.action}」为演示入口，当前站点未接入真实服务。`)}
                    className={
                      isPrimary
                        ? 'inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600'
                        : isSecondary
                          ? 'inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-secondary-600'
                          : 'inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2.5 font-label text-sm text-background-100 transition-colors duration-200 hover:bg-background-50/10'
                    }
                  >
                    {entry.action}
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line text-base" />
                    </span>
                  </button>
                  <span className="font-label text-[11px] text-background-400">{entry.meta}</span>
                </div>
              </div>
            );
          })}
        </div>

        {toast ? (
          <div className="mt-6 flex justify-center">
            <div className="animate-fade-up flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-5 py-2.5 backdrop-blur-sm">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-information-line text-base text-accent-400" />
              </span>
              <span className="font-label text-[13px] text-background-100">{toast}</span>
            </div>
          </div>
        ) : null}
      </div>
    </section>
  );
}